import { render, staticRenderFns } from "./MediumProtocolSetting.vue?vue&type=template&id=317f37a6"
import script from "./MediumProtocolSetting.vue?vue&type=script&lang=js"
export * from "./MediumProtocolSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports